module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Copyright © 1967 by Arnoldo Mondadori Editore–Milano")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("English translation copyright © 1967 by Harcourt, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Copyright renewed 1995 by Harcourt, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("Originally published in Italy: in Russian, as "), _c('em', [_vm._v("Krutoj Mars rut;")]), _vm._v(" in Italian, as "), _c('em', [_vm._v("Viaggio nella Vertigine.")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Ginzburg, Evgenia Semenovna."), _c('br'), _vm._v("\nJourney into the whirlwind."), _c('br'), _vm._v("\n“A Helen and Kurt Wolff book.”"), _c('br'), _vm._v("\nTranslation of Kruto marshrut.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1. Political prisoners—Russia—Personal narratives. 2. Russia—Social conditions—1917— I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("[DK268.3.G513 1975] 365'6'0924[B] 74-16406")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 0-15-602751-8 (Harvest: pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-54101-3"), _c('br'), _vm._v("\nv3.1020")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0